import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
export default EmberDataBaseFragment.extend({
  blockedTaxes: fragmentArray('blocked-taxes')
}).reopenClass({
  _modelNameForMigration: 'pricing-blocklists'
});